import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setAlert, setUserLogOut } from "../reducers/userConfigSlice";

// MenuMobile clears this origin's localStorage when the operator logs out.
// Storage events are delivered only to other tabs on the same origin.
export default function useLogoutSync() {
  const dispatch = useDispatch();
  const logged = useSelector(state => state.aplicationConfig.userConfig.logged);
  useEffect(() => {
    const onStorage = event => {
      if (!logged || event.storageArea !== window.localStorage || event.key !== null) return;
      dispatch(setUserLogOut());
      sessionStorage.clear();
      dispatch(setAlert({
        called: true,
        title: "Sesión cerrada",
        message: "Se ha cerrado la sesión en otra pestaña. Inicie sesión para continuar.",
        type: "info",
      }));
    };
    window.addEventListener("storage", onStorage);
    return () => window.removeEventListener("storage", onStorage);
  }, [dispatch, logged]);
}
